import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AvatarModule } from 'primeng/avatar'
import { DividerModule } from 'primeng/divider'
import { InterventionTechnicianModel } from '../../../../core/models/intervention-calendar.model'

@Component({
  selector: 'app-intervention-technicians',
  standalone: true,
  imports: [CommonModule, AvatarModule, DividerModule],
  templateUrl: './intervention-technicians.component.html',
  styleUrls: ['./intervention-technicians.component.scss'],
})
export class InterventionTechniciansComponent {
  @Input() technicians: InterventionTechnicianModel[] = []
  @Input() assistant: InterventionTechnicianModel | null = null
}
